var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "content-tree-viewer" }, [
    _c(
      "div",
      { staticClass: "breadcrumbs" },
      [
        _c("KBreadcrumbs", {
          attrs: { items: _vm.breadcrumbs, showSingleItem: true },
        }),
      ],
      1
    ),
    _vm.annotatedChildNodes.length > 0
      ? _c(
          "div",
          { staticClass: "contents" },
          [
            _c("CoreTable", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "headers",
                    fn: function () {
                      return [
                        _c(
                          "th",
                          { staticClass: "core-table-checkbox-col select-all" },
                          [
                            _c("KCheckbox", {
                              attrs: {
                                label: _vm.$tr("selectAll"),
                                checked: _vm.nodeIsChecked(
                                  _vm.annotatedTopicNode
                                ),
                                disabled: _vm.disableSelectAll,
                              },
                              on: { change: _vm.toggleSelectAll },
                            }),
                          ],
                          1
                        ),
                        _c("th"),
                        _c("th"),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "tbody",
                    fn: function () {
                      return [
                        _c(
                          "transition-group",
                          { attrs: { tag: "tbody", name: "list" } },
                          _vm._l(
                            _vm.showableAnnotatedChildNodes,
                            function (cNode) {
                              return _c("ContentNodeRow", {
                                key: cNode.id,
                                attrs: {
                                  checked: _vm.nodeIsChecked(cNode),
                                  disabled:
                                    _vm.disabled ||
                                    _vm.disableAll ||
                                    cNode.disabled ||
                                    (cNode.updated_resource &&
                                      !cNode.available),
                                  indeterminate: _vm.nodeIsIndeterminate(cNode),
                                  message: cNode.message,
                                  node: cNode,
                                  getLinkObject: _vm.topicLinkObject,
                                },
                                on: {
                                  changeselection: function ($event) {
                                    return _vm.toggleSelection(cNode)
                                  },
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1282071564
              ),
            }),
          ],
          1
        )
      : _c("div", { staticClass: "no-contents" }, [
          _vm._v("\n    " + _vm._s(_vm.$tr("topicHasNoContents")) + "\n  "),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }